import { Icon } from '../icons.tsx';

export default function SoftwareFactory() {
  const capabilities = [
    { icon: 'cpu', t: 'Standards-based engineering' },
    { icon: 'shuffle', t: 'Componentised, portable architectures' },
    { icon: 'rocket', t: 'Accelerated time-to-market' },
    { icon: 'shield-check', t: 'Built-in governance &amp; security' },
  ];
  return (
    <section className="section sf" id="software-factory">
      <div className="container sf__grid">
        <figure className="sf__figure reveal">
          <img
            src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80"
            alt="A modern, well-lit collaborative workspace"
            loading="lazy" decoding="async" width="1200" height="800"
          />
        </figure>
        <div className="sf__copy">
          <p className="eyebrow reveal">Software Factory &amp; Solutions Centre</p>
          <h2 className="section__title reveal" style={{ '--d': '60ms' }}>
            The build centre behind every Softfinity engagement.
          </h2>
          <p className="sf__lead reveal" style={{ '--d': '120ms' }}>
            Our Software Factory and Solutions Centre is where we design, build, and test
            enterprise solutions before they reach your team: standards-based, portable,
            and built to last.
          </p>
          <ul className="sf__capabilities reveal" style={{ '--d': '180ms' }}>
            {capabilities.map((c) => (
              <li key={c.t}>
                <span className="sf__capability-icon"><Icon name={c.icon} size={18} /></span>
                <span dangerouslySetInnerHTML={{ __html: c.t }} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
